// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const FlowAuth = () => ({
   restrict: 'A',
   replace: true,
   controller: 'FlowAuthCtrl',
   templateUrl: "/assets/flow/auth.html"
})

const FlowBanner = () => ({
   restrict: 'A',
   replace: true,
   controller: 'FlowAuthCtrl',
   templateUrl: "/assets/flow/banner.html"
})

const FlowAuthForm = () => ({
   restrict: 'A',
   replace: true,
   controller: 'FlowAuthCtrl',
   templateUrl: "/assets/flow/authForm.html",

   link(scope: any, element: any, attrs: any) {
      const {
         flowConfigs
      } = scope
      scope.formAction = attrs.isSignup ? flowConfigs.signupUrl : flowConfigs.authUrl
      return scope.submitText = attrs.flowAuthForm || flowConfigs.loginText
   }
})

const FlowLogoutForm = () => ({
   restrict: 'A',
   replace: true,
   controller: 'FlowAuthCtrl',
   templateUrl: "/assets/flow/logoutForm.html"
})

const FlowSignOff = () => ({
   restrict: 'A',
   controller: 'FlowAuthCtrl',

   link(scope: any, element: any) {
      element.on('click', () => scope.signOff())

      return scope.$on('$destroy', () => element.off('click'))
   }
})

const FlowToggleForm = () => ({
   restrict: 'A',
   replace: true,
   controller: 'FlowAuthCtrl',
   templateUrl: '/assets/flow/toggleForm.html',

   link(scope: any, element: any, attrs: any) {
      if (attrs.flowToggleForm === 'folder') {
         scope.placement = 'bottom'
         return scope.classes = 'uxf-icon uxf-folder navSave'
      } else {
         scope.placement = 'top'
         return scope.classes = 'uxf-icon uxf-folder-add'
      }
   }
})

angular.module('summonApp.directives')
   .directive('flowAuth', FlowAuth)
   .directive('flowBanner', FlowBanner)
   .directive('flowAuthForm', FlowAuthForm)
   .directive('flowLogoutForm', FlowLogoutForm)
   .directive('flowSignOff', FlowSignOff)
   .directive('flowToggleForm', FlowToggleForm)
